module.exports = {
          srcSet: __webpack_public_path__ + "6772daebb83878df20019d2469a85b32-79.png"+" 79w",
          images:[ {path: __webpack_public_path__ + "6772daebb83878df20019d2469a85b32-79.png",width: 79,height: 79}],
          src: __webpack_public_path__ + "6772daebb83878df20019d2469a85b32-79.png",
          toString:function(){return __webpack_public_path__ + "6772daebb83878df20019d2469a85b32-79.png"},
          
          width: 79,
          height: 79
        }